/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Clock1220/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Clock1220({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Clock1220",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Clock1220.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-1r2Q5A': alignSelf,'--mt-2-1r2Q5A': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1r2Q5A': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1r2Q5A': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1r2Q5A': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1r2Q5A': opacity,'--w-10-1r2Q5A': typeof width === 'number' ? `${width}px` : width,'--h-11-1r2Q5A': typeof height === 'number' ? `${height}px` : height,'--f-12-1r2Q5A': fill,'--a-7-1r2Q5A': isAnimated ? animation : "none",'--sd-8-1r2Q5A': isAnimated ? strokeDashoffset : 0,'--sd-9-1r2Q5A': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Clock1220.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6 12A6 6 0 106 0a6 6 0 000 12zm.536-8.143a.536.536 0 10-1.072 0V6c0 .125.044.247.124.343l2.143 2.571a.536.536 0 10.823-.686L6.536 5.806V3.857z"
 style={{'--f-12-1r2Q5A': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}